import { render, staticRenderFns } from "./Habilidades.vue?vue&type=template&id=69fe068a&scoped=true"
import script from "./Habilidades.vue?vue&type=script&lang=js"
export * from "./Habilidades.vue?vue&type=script&lang=js"
import style0 from "./Habilidades.vue?vue&type=style&index=0&id=69fe068a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69fe068a",
  null
  
)

export default component.exports